const ROUNDED_UNIT_NAMES = ['g', 'ml'];

export const isRoundedUnit = (unitName) => ROUNDED_UNIT_NAMES.includes(unitName);

export const roundQuantityForDisplay = (value, unitName) => {
    const quantity = Number(value) || 0;

    if (!isRoundedUnit(unitName)) {
        return Math.round(quantity * 10) / 10;
    }

    if (quantity <= 0) {
        return 0;
    }

    if (quantity < 5) {
        return Math.max(1, Math.round(quantity));
    }

    const rounded = Math.round(quantity);
    const lastDigit = rounded % 10;

    if (lastDigit <= 3) {
        return rounded - lastDigit;
    }

    if (lastDigit <= 6) {
        return rounded - lastDigit + 5;
    }

    return rounded - lastDigit + 10;
};
